import React from 'react';

// A small bilingual hover tooltip rendered as a translucent white bubble.
// Shows the English label on top, a thin 25% black divider, and the Russian
// label below. Hidden on touch devices via CSS.
export const BilingualTooltip = ({ en, ru, children }) => {
  return (
    <span className="tip-wrap">
      {children}
      <span className="tip-bubble" role="tooltip" aria-hidden="true">
        <span className="tip-bubble__line">{en}</span>
        <hr className="tip-bubble__divider" />
        <span className="tip-bubble__line">{ru}</span>
      </span>
    </span>
  );
};
